var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScoobyDoo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_393",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29243",
    "data-name": "Group 29243",
    transform: "translate(360 10837)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -360, -10837)",
    filter: "url(#Ellipse_393)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_393-2",
    "data-name": "Ellipse 393",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50248",
    "data-name": "Path 50248",
    d: "M30.374,10.567a5.163,5.163,0,0,0-4.746,0c-1.773.887-2.889-.574-3.39-1.356-1.056-1.649-2.472-2.005-4.746-1.356-4.746,1.356-6.61,6.017-7.288,10.762s2.542,16.356,2.542,16.356H26.307a68.8,68.8,0,0,0-1.656-8.648A5.314,5.314,0,0,0,25.763,24.7a2.194,2.194,0,0,0,1.9-1.93,1.517,1.517,0,0,0-.026-.192c1.872.409,1.412-1.858,4.093-3.2C34.442,18.024,31.73,11.245,30.374,10.567Z",
    transform: "translate(-344.384 -10822.432)",
    fill: "#b0720c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50249",
    "data-name": "Path 50249",
    d: "M11.724,11.525s-4.28-3.39-2.034-6.1C9.012,2.712,9.691.037,11.046,0,12.117-.029,12.4,3.39,12.4,3.39s3.39,1.356.678,5.424A2.937,2.937,0,0,1,11.724,11.525Z",
    transform: "translate(-344.039 -10820)",
    fill: "#b0720c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50250",
    "data-name": "Path 50250",
    d: "M23.39,0c-.678,0-1.356,1.356-2.712,2.034C19.465,2.64,21.356,4.746,20,6.1a5.217,5.217,0,0,1,4.068.678s2.34-2.693-.372-4.049C24.9,1.269,24.746,0,23.39,0Z",
    transform: "translate(-347.569 -10820)",
    fill: "#b0720c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50251",
    "data-name": "Path 50251",
    d: "M19.909,19s-.918,3.337,1.262,3.556c1.035.1,1.493-1.406,2.228-1.277s-.389,4.2,2.423,4.976,7.487-1.515,7.616-5.842c-.692-.043-.908-.043-.908-.043A5.6,5.6,0,0,1,26.6,25.26c-3.073-.033-1.3-4.414-2.9-4.782-1.459-.335-1.58,1.039-2.466,1.039C19.72,21.517,19.909,19,19.909,19Z",
    transform: "translate(-347.478 -10826.119)",
    fill: "#6d4408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50252",
    "data-name": "Path 50252",
    d: "M19.34,26.128c1.125,7.2,6.729,8.568,8.352,4.457a1.052,1.052,0,0,1,.822.216C28.168,33.982,20.055,37.682,19.34,26.128Z",
    transform: "translate(-347.356 -10828.415)",
    fill: "#6d4408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50253",
    "data-name": "Path 50253",
    d: "M28.085,30.45s1.9,1.861,4.024,1.255,1.19-3.981,1.19-3.981l-1.06.389s.908,2.294-.519,2.769S28.085,30.45,28.085,30.45Z",
    transform: "translate(-350.172 -10828.929)",
    fill: "#6d4408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50254",
    "data-name": "Path 50254",
    d: "M21.534,10A3.338,3.338,0,0,0,19,12.872c-.09,1.483,2.943,1.976,3.346-.834C22.574,10.463,21.823,9.994,21.534,10Z",
    transform: "translate(-347.247 -10823.221)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50255",
    "data-name": "Path 50255",
    d: "M26.48,10.473c.723,0,1.433.927,1.506,2.112s-1.771,1.66-2.094-.587C25.712,10.739,26.249,10.468,26.48,10.473Z",
    transform: "translate(-349.455 -10823.373)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50256",
    "data-name": "Path 50256",
    d: "M11.992,1.518c-.051.583-.519,5.453.1,6.946s2.142,1.136,2.759-.584a3.453,3.453,0,0,0-1.525-4.447c-.033-.714-.162-1.1-.292-2.077S12.154-.332,11.992,1.518Z",
    transform: "translate(-344.92 -10820.118)",
    fill: "#ffccbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50257",
    "data-name": "Path 50257",
    d: "M24.41,2.351a2.048,2.048,0,0,0-1.4,3.051c.681,1.039,1.947-.129,1.363-1.136A1.875,1.875,0,0,1,24.41,2.351Z",
    transform: "translate(-348.445 -10820.757)",
    fill: "#ffccbc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_479",
    "data-name": "Ellipse 479",
    cx: 0.678,
    cy: 0.678,
    r: 0.678,
    transform: "translate(-326.213 -10811.864)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_480",
    "data-name": "Ellipse 480",
    cx: 0.678,
    cy: 0.678,
    r: 0.678,
    transform: "translate(-323.501 -10811.864)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50258",
    "data-name": "Path 50258",
    d: "M34.524,27.434s.7,1.639,1.8,1.152,1.233-1.85,2.126-2.418c-1.331.681-1.753,1.428-2.272,1.525s-.746-.617-.746-.617Z",
    transform: "translate(-352.246 -10828.428)",
    fill: "#6d4408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50259",
    "data-name": "Path 50259",
    d: "M37.424,18.457C35.986,18.937,32,17.1,32,15.068A4.374,4.374,0,0,1,36.068,11c2.034,0,4.068.678,4.068,2.034S39.457,17.78,37.424,18.457Z",
    transform: "translate(-351.433 -10823.543)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50260",
    "data-name": "Path 50260",
    d: "M21.761,8.134A3.157,3.157,0,0,0,18.83,9.757C19,7.009,21.145,6.965,21.761,8.134Z",
    transform: "translate(-347.192 -10822.386)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8463",
    "data-name": "Rectangle 8463",
    width: 17.627,
    height: 2.712,
    transform: "translate(-334.348 -10790.17)",
    fill: "#26c6da"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoobyDoo);
export default __webpack_public_path__ + "static/media/scoobyDoo.737f6756161f2109441d5e3738108063.svg";
export { ForwardRef as ReactComponent };